module.exports = __webpack_public_path__ + "img/s3.04f3c7d1.svg";